import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heart } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#2A3C48] text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center">
          <h3 className="text-2xl font-playfair font-bold mb-4">{t('footer.title')}</h3>
          <p className="text-white/70 mb-6">{t('footer.subtitle')}</p>
          
          <div className="flex flex-col gap-4 items-center justify-center text-sm text-white/60">
            <p>{t('footer.copyright', { year: 2025 })}</p>
            <a 
              href='https://api.whatsapp.com/send/?phone=5584987871161&text&type=phone_number&app_absent=0' 
              target='_blank' 
              rel="noopener noreferrer"
            >
              {t('footer.site_by')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
